import { Map } from 'immutable'
import * as actions from './actions'

export const initialState = Map({
  componentName: null,
  isOpen: false,
})

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.RENDER_MODAL:
      return state
        .set('componentName', action.payload.name)
        .set('isOpen', true)
        .set('props', action.payload.props)
    case actions.REMOVE_MODAL:
    case actions.DISMISS_MODAL:
      return state
        .delete('componentName')
        .delete('isOpen')
        .delete('props')
        .delete(action.payload.name)
    default:
      return state
  }
}
